import { useLocation } from 'react-router-dom';
import { CRUDPathSegmentEn } from '../constants';
export const useCheckForm = (formMode) => {
    const location = useLocation();
    const isEditForm = !formMode ? location.pathname.includes(`${CRUDPathSegmentEn.EDIT}/`) : formMode === 'editForm';
    const isAddForm = !formMode ? location.pathname.includes(`${CRUDPathSegmentEn.ADD}`) : formMode === 'addForm';
    const isDetailForm = !formMode
        ? location.pathname.includes(`${CRUDPathSegmentEn.DETAIL}/`)
        : formMode === 'detailForm';
    return { isEditForm, isAddForm, isDetailForm };
};
